import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Assets from "../Assets";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

const AppContent = ({ app, isReadOnly }) => {
	const classes = useStyles();

	const contentStyle = {
		transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)",
		marginTop: 2,
	};

	return (
		
			<div className={classes.root}>
				{app.id ? (
					<Grid style={contentStyle}>
						<Assets app={app} isReadOnly={isReadOnly} />
					</Grid>
				) : (
					<div />
				)}
			</div>
		
	);
};
export default AppContent;
